let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6nYFs")).then(() => parcelRequire('4pl6C'));